import React from 'react';
import styled from 'styled-components';
// import { lighten } from 'polished';
import SocialIcon from './SocialIcon';
import { theme } from '../utils/theme';

const Container = styled.footer`
  padding: 7rem 0;
  padding-bottom: 1rem;
  background-color: ${theme.darkAccent};
  line-height: 30px;
  li,
  p {
    margin-bottom: 1rem;
    font-size: ${theme.fontSizeMedium}px !important;
  }

  .container {
    position: inherit !important;
  }
  a {
    transition: 0.1s !important;

    :hover {
      color:  ${theme.borderColor}; !important;
    }
  }
  h1 {
    margin-bottom: 32px;
  }
`;

const LogoImg = styled.img`
  max-height: 7rem;
  margin-top: -0.7rem;
`;

const Bottom = styled.div`
  padding: 2rem !important;
  background-color: ${theme.darkAccent};
`;

const information = [
  { id: 1, name: 'FAQ', url: '/page/faq' },
  {
    id: 2,
    name: 'Find us',
    url:
      'https://www.google.co.uk/maps/place/Midas+Brush+Decorating+Ltd/@51.5235464,-0.3270559,10z/data=!3m1!4b1!4m5!3m4!1s0x48761d651e743bc5:0x58af084bccd7b2fc!8m2!3d51.5238801!4d-0.0468676',
  },
  { id: 3, name: 'Past Projects', url: '/blog' },
];
const Footer = ({ home }) => {
  return (
    <>
      <Container className="section">
        <div className="container">
          <div className="columns  ">
            <div className="column has-text-centered ">
              <h1 className="has-text-weight-normal has-text-white is-size-5">
                Contact Us
              </h1>
              <ul>
                {home.telephone && (
                  <li className="has-text-white">
                    <a href={`tel:${home.telephone}`}>{home.telephone}</a>
                  </li>
                )}
                {home.email && (
                  <li className="has-text-white">
                    <a href={`mailto:${home.email}`}>{home.email}</a>
                  </li>
                )}
                {home.address && (
                  <li className="has-text-white">
                    <span>{home.address}</span>
                  </li>
                )}
              </ul>
            </div>
            <div className="column has-text-centered is-5">
              <LogoImg
                src="/images/logo.png"
                alt="footer-logo"
                className="mb-5"
              />
              {home.footerDescription && (
                <p className="has-text-white is-size-3">
                  {home.footerDescription}
                </p>
              )}
            </div>
            <div className="column has-text-centered">
              <h1 className="has-text-weight-normal has-text-white is-size-5">
                Our Information
              </h1>
              <ul>
                {information.map((item) => (
                  <li key={item.id}>
                    <a href={item.url} className="has-text-white">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="has-text-centered is-flex is-justify-content-center">
            <SocialIcon home={home} />
          </div>
        </div>
      </Container>
      <Bottom className="has-text-centered ">
        <h2 className="has-text-white">
          Copyright © 2021 - Brilliant Floor Care
        </h2>
      </Bottom>
    </>
  );
};
export default Footer;
